var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTelmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.749mm",
    height: "15.459mm",
    viewBox: "0 0 17.749 15.459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient257",
    x2: 1,
    gradientTransform: "matrix(47.066 -47.066 -47.066 -47.066 91.277 3049.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0.48543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16428f",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient279",
    x2: 1,
    gradientTransform: "matrix(47.066 -47.066 -47.066 -47.066 78.78 3037.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0.48543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16428f",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient301",
    x2: 1,
    gradientTransform: "matrix(47.066 -47.066 -47.066 -47.066 82.061 3040.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0.48543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16428f",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient323",
    x2: 1,
    gradientTransform: "matrix(47.066 -47.066 -47.066 -47.066 83.982 3042.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a299",
    offset: 0.48543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16428f",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,3049.12 H 1280 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath341"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46 3077.1h123v-116h-123z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask347",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath345)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(123 0 0 116 46 2961.1)"
  }, /*#__PURE__*/React.createElement("image", {
    transform: "matrix(1,0,0,-1,0,1)",
    width: 1,
    height: 1,
    imageRendering: "optimizeSpeed",
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB0CAYAAAClkU2qAAAABHNCSVQICAgIfAhkiAAABXFJREFUeJztnOly6jgQRj/ZxmC25P2flGu8zI+pdtpCXmFGuunvVKlkA6kYjlqtFosD0IOYIIt9AeT/g7INQdmGoGxDULYhKNsQlG0IyjYEZRuCsg1B2YagbENQtiEo2xCUbQjKNgRlG4KyDUHZhqBsQ1C2ISjbEJRtCMo2BGUbgrINQdmGKGJfwBLOudF53/OraXtxSOSLfb5U/3wNnxoIv3VARY9skeqcG5o+DxGSMSVoSZylARI1srVg5xyyLBuaL1+QF9Xv3z1eum/qtq2PjUk02VpmnudDK4oCeZ6/SNdyddO3bTl+pxf2DKiYRJ3GRXRRFDgcDjgcDijLEmVZDtK1bL91XTd7vqcBWHXu93pAClO3xyKKbH/qLooCx+MRVVXhdDrhdDrheDwOwoWu616aSJ67XQ8Ev58bJHODB5geFHKckmggYmRr0WVZ4nQ64XK54Hq94nK5oKqqIcIBjOS1bYu2bYPHuvePp1poYMwNjqnWdd3oOYroVKRHl53nOcqyRFVVuF6v+Pr6wv1+x/V6HaI7y7JBQNM0aNv2pZfmn/uDYu+AWJLfdd1wnT4piAYi52yRLdP4+XzG7XbD9/c37vc7qqrC4XCAc26Q0jTN0J7P5+hcD4A9g2FqdtBNrgXAKJp1ySj3aVKI7mRytj+V3243nM9nlGU5kv18Poemhfv91CDIsmwkXs6dc2jbdrg+3QM/OVhft8jX+dnvUyL6poqUWHmeD6txWaRJ3hbZTdOMyrTn8xmsy+dqdL2AyrLsZSoObe5Ir9tUGbamTItF9NJLen9jRUvVL7BE+BbJPiERfm38bumWIlFlh170qTzp59m5FfnWNvV3W1bzc+VaKkSfxvWLpBdhkpcBDLL17XVdj/L3VC6fa2sHwZrVeUi0fo4pkIRsX3Jd16jrGnmejxZPWvY7oqdW5XskT9Xf8txSIors0GaErLRF9OPxgHMOTdOMFmh+ZOvblkTPlV9LpddSja2flxzrPgWi5+xQZP/582eor2UHzZc9V35tjeQ9U/bc9ql+fikRXbafq+u6HmQDmJS9R7Ich3bUfNlT26Zz03WK0axJNmc/Hg/0fY+iKIbHhHbOfNFLO2hrd8rmpm257pDcVEUDEWWHcraexuXdLlmRa9l7Ja8tp5am7L9NspBsZOd5jr7vh96X/Y7kkOytK+zUp+wQ0XO2zo06J4vkLPv30846726RvCWa5zZF/tZo1iQR2X3fj2TWdT280RCSHeqnFmChxVdoAfbbpuwQyeRsXWvr97Bln1tkLdXMIdG/tZTaSlKRrRdfsmsm70xpiczL+0hCdmhfHPipsQG81MafzMtyHb9pyg4RfYEmvZYtZZdM4/r+kHTm5XVE2xvXx1qW5G1gWbaFLc5PEj2yQ+WXLMpkJQ7gRbaVLc5PkkTO1pErn0ABfmRrida2OD9JMpGthesP7enH+bLXRrJ1yUL0yAbCkTsne8sCTP+9/n8WiS47FNlyu/4UJ/Py+0SfxvVqW38yVO+e+fXxVM2sHyvH+n9ZJ+p2qf/tTF1q6ZW4/xjm5X1En8aBV5n+h/Dn5HLKXk8SsgG8yPa/erNWsn9MfoguW4vRokOy9TElbyeJBZoc+/f55yyl3iN6ZAPLv1LAvPwZkvgdtNA3JoWpCKbo7SQhGxgLnvtVQ0reTzKyhS0/dEe2kZxs8t/BXyU2BGUbgrINQdmGoGxDULYhKNsQlG0IyjYEZRuCsg1B2YagbENQtiEo2xCUbQjKNgRlG4KyDUHZhqBsQ1C2ISjbEJRtCMo2BGUbgrINQdmGoGxDULYhKNsQlG0IyjYEZRuCsg1B2YagbENQtiEo2xCUbQjKNgRlG4KyDfEPSe2SYBSGPMAAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath345"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46 3077.1h123v-116h-123z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask359",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    imageRendering: "optimizeSpeed",
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB0CAAAAACA+hJ2AAAAAXNCSVQI5gpbmQAAAw5JREFUaIHtmNuW2jAMRc+xAwOd6eX/v7TFkk4f7ITAdDUGstoX70DmYbLYlmXJSYDBYDAYDAaDwWAwGPwP+MiF+udu3l/2eQjPDWraNpMEeXXoRvfCQLbiJsmUElnnXBDuP/Of9aC6/BtukjnnKadECpKEm8/dcTeoDbbmnHk6HI7HKZOSpGjfG7B8IYgC2vkVN8k0vZ1Pp7cpAxERofmserSRxM0outRbcTNNx9P7x/v5OEER7uEeHh7h0dB1JI0AIGzbN935eP74/u3jbUoR5ubm7ubuHu63g5j9kQLoSfhWvlOe3r58/fHtfGC4mRUzM7ebMdSJiAgGFCAIAduBd+T7eHr/+PrlyPBSitWjjiC5W3I6CAIimYKqx2bUHb0lpXw4nk7nI8NyziUlkq3cBSVJQbL2oLrEr+X2mpsgmVLOmVT4yoz28xLwqea2tF1uAahlRfe2xMLXRDsvK64V3OtuSBFupYBupVxKKTXrjesIlrWukLoa27Y73Mrlkp1updyp3T6Zo3/W/+6WpPByufykMayUS7GruhXZXGNzec+N/uW4pXArvw6cEFbmIlvHfDPd826zQ9yAItwuvw6o7huz1d4WPndVLftJh7k73z81KcxKbWxzX7t2tDbfdbp77x423GpznlEQdme+Ftayjzxg7o47KyvM7s1+v7h7p7vLLUVYKVkJ7mvzKujWSx4LusMNyd0uKRLc2x5qHm2JhWLZtR81d+U7vEwpCI+5pMPvE91dVw+4AcnNCj0pfK9Ed7sj3AomIPyPiX6srh5xCwq3jKCiblk7JLrLrRq3l8X9dAN92N0WmxEJWO5Pn2qgT7ghhaeEBEW80kCfcNddlGK9iVjF/Kq5I+4ab3Ov1tgrie51SwqHKOyX6E63qCARhJbHr5cT3cgb/ydIUNCeiW505FsKru7Bd5luAB1xk/U1z9q800uf7TmvXB+u93vdtL3WlmerXepqzVbc9RETmB/x9nzFtume5d1vcPZ0X+P+D+8V54t2Ng8Gg8FgMBgMBoPBYDAYDAaDwaCX3x9y0wGIFt1XAAAAAElFTkSuQmCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-178.78 -230.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 149.73 1303.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107.51 3024.6 6.503 6.399h13.653v5.367h-40.309v-5.367h13.654z",
    fill: "url(#linearGradient257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.7 3015.6v-13.737h11.633v13.738l-5.818-5.726z",
    fill: "url(#linearGradient279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.379 3021.1 8.134-8.008 8.137 8.007v-19.273h12.019v26.861h-12.703l-7.453-7.333-7.449 7.333h-12.704v-26.861h12.019z",
    fill: "url(#linearGradient301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.99 3028.7v-29.18h-44.946v39.184h44.946zm-47.629-31.497h50.311v43.82h-50.311z",
    fill: "url(#linearGradient323)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 149.73 1303.1)",
    clipPath: "url(#clipPath333)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath341)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask347)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(123 0 0 116 46 2961.1)"
  }, /*#__PURE__*/React.createElement("image", {
    transform: "matrix(1,0,0,-1,0,1)",
    width: 1,
    height: 1,
    imageRendering: "optimizeSpeed",
    mask: "url(#mask359)",
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB0CAYAAAClkU2qAAAABHNCSVQICAgIfAhkiAAAASNJREFUeJzt0UENACAQwDDAv+fDBTzWKliyPTOzSDi/A3jH7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQy5bTgTkOdK0sgAAAABJRU5ErkJggg=="
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTelmed);
export default __webpack_public_path__ + "static/media/logo-telmed.6c872bf3874b6495c0340887bb928843.svg";
export { ForwardRef as ReactComponent };